import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterState } from "./type";

const initialState: FilterState = {
  filters: {
    search: "",
    status: "",
    order: {},
    meta: {
      page: 1,
      perPage: 20,
    },
  },
};

const GamificationFilterSlice = createSlice({
  name: "GamificationFilter",
  initialState,
  reducers: {
    updateFilter(
      state,
      action: PayloadAction<{ key: string; value: unknown }>
    ) {
      const { key, value } = action.payload;
      
      if (key === "meta") {
        state.filters.meta = { ...state.filters.meta, ...(value as object) };
      } else {
        (state.filters as Record<string, unknown>)[key] = value;
      }
      
      if (key !== "meta") {
        state.filters.meta = { ...state.filters.meta, page: 1 };
      }
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, resetFilters } = GamificationFilterSlice.actions;
export default GamificationFilterSlice.reducer;
